// extracted by mini-css-extract-plugin
export default {"container":"ItemInfo_container_gTJUJ","files":"ItemInfo_files_mK3nE"};